import React, { useMemo, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

import {
  Grid, Typography, Tooltip, IconButton, Divider, Link,
  Accordion, AccordionSummary,
  Chip, Fab, InputBase, InputAdornment, Button, Checkbox, FormControlLabel,
  Card, CardContent, TextField,
  List, ListItem, ListItemSecondaryAction, ListItemText
} from '@material-ui/core'

import {
  // Delete as DeleteIcon,
  Search as SearchIcon, Clear as ClearIcon, Add as AddIcon
} from '@material-ui/icons'

import { makeStyles, fade, withStyles } from '@material-ui/core/styles'

import { cloneDeep } from 'lodash'

import {
  getDestinationLists, addDestinationList
  // deleteDestinationList
} from '../../../../../redux/actions'

import { NotificationToast, ConfirmToast } from '../../../tools'

import { ValidateUrl, parseUnitInfo } from '../../../../../utils'

// import { truncateText } from '../../../../../utils'

const learnsafeGreen = '#A4D164'
const learnsafeRed = '#e57373'
const learnsafeBlue = '#5291fc'

const CustomTextField = withStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: 'black'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: learnsafeGreen
    },
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing(1.5, 2)
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: learnsafeGreen
      }
    }
  }
}))(TextField)

const GreenCheckbox = withStyles({
  root: {
    color: learnsafeGreen,
    '&$checked': {
      color: learnsafeGreen
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const useStyles = makeStyles((theme) => ({
  listName: {
    fontWeight: 600,
    color: learnsafeBlue
  },
  deleteBtn: {
    backgroundColor: learnsafeRed,
    color: '#fff',
    '&:hover': {
      backgroundColor: fade(learnsafeRed, 0.85)
    },
    '&:disabled': {
      backgroundColor: fade(learnsafeRed, 0.5)
    }
  },
  countChip: {
    backgroundColor: learnsafeBlue,
    color: '#fff'
  },
  interactiveContainer: {
    width: '100%',
    margin: 'auto'
  },
  destinationListContainer: {
    maxHeight: '60vh',
    overflowY: 'scroll',
    background: theme.palette.background.default
  },
  listContainer: {
    overflowX: 'scroll',
    margin: 'auto',
    width: '100%'
  },
  accordionContent: {
    width: '100%'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '100%'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  searchInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  searchRoot: {
    width: '100%'
  },
  newListBtn: {
    backgroundColor: learnsafeBlue,
    color: '#FFF',
    '&:hover': {
      backgroundColor: fade(learnsafeBlue, 0.85)
    }
  },
  unitListBtn: {
    backgroundColor: fade(learnsafeBlue, 0.20),
    width: '100%',
    fontWeight: 600,
    color: theme.palette.text.primary,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(1),
    '&:hover': {
      backgroundColor: fade(learnsafeBlue, 0.35)
    }
  },
  unitListContainer: {
    width: '100%',
    margin: theme.spacing(0, 'auto'),
    maxHeight: '30vh',
    overflowY: 'scroll'
  },
  destinationListUnit: {
    fontWeight: 600,
    color: learnsafeGreen,
    textDecoration: 'underline'
  },
  addDestinationBtn: {
    backgroundColor: learnsafeGreen,
    color: '#FFF',
    '&:hover': {
      backgroundColor: fade(learnsafeGreen, 0.85)
    },
    '&:disabled': {
      backgroundColor: fade(learnsafeGreen, 0.5)
    }
  },
  clearDestinationBtn: {
    backgroundColor: learnsafeRed,
    color: '#fff',
    '&:hover': {
      backgroundColor: fade(learnsafeRed, 0.85)
    }
  },
  displayCheckbox: {
    margin: theme.spacing(0)
  },
  destinationsList: {
    maxHeight: '12.5vh',
    overflowY: 'scroll'
  }
}))

const CiscoLists = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const { destinationLists: ciscoLists, ciscoUmbrellaSettings: { units: ciscoUnitSettings } = {} } = useSelector(state => state.integrations)
  const TreeData = useSelector(state => state.auth.unitTree)

  const [destinationLists, setDestinationLists] = useState([])
  const [unitDisplays, setUnitDisplays] = useState([])
  const [filteredLists, setFilteredLists] = useState([])
  const [destinations, setDestinations] = useState([])
  const [destinationListUnit, setDestinationListUnit] = useState([])

  const [isCreatingNew, setIsCreatingNew] = useState(false)

  const [destinationListName, setDestinationListName] = useState('')
  const [newDestination, setNewDestination] = useState('')
  const [searchVal, setSearchVal] = useState('')

  const [unitSettings, setUnitSettings] = useState({})

  useMemo(() => { if (TreeData) { setUnitDisplays(parseUnitInfo(TreeData)) } }, [TreeData])

  useEffect(() => { dispatch(getDestinationLists()) }, [dispatch])

  useMemo(() => { if (ciscoUnitSettings && typeof ciscoUnitSettings === 'object') { setUnitSettings(cloneDeep(ciscoUnitSettings)) } }, [ciscoUnitSettings])

  useMemo(() => {
    if (ciscoLists && Array.isArray(ciscoLists) && Array.isArray(unitDisplays)) {
      const mappedLists = ciscoLists.reduce((arr, listInfo) => {
        if (listInfo && listInfo.destinationListID) {
          if (listInfo.mappings && Boolean(listInfo.mappings.length)) {
            const displayInfo = listInfo.mappings.reduce((arr2, mappingInfo) => {
              if (mappingInfo && mappingInfo.unitID) {
                const displayInfo = unitDisplays.find((unitInfo) => unitInfo && unitInfo.unitID === mappingInfo.unitID)
                if (displayInfo) { arr2.push({ ...displayInfo }) } else { arr2.push({ ...mappingInfo }) }
              }
              return arr2
            }, [])

            listInfo.mappings = displayInfo
          }

          arr.push({ ...listInfo })
        }

        return arr
      }, [])

      setDestinationLists(mappedLists)
    }
  }, [ciscoLists, unitDisplays])

  useMemo(() => {
    if (destinationLists && searchVal != null) {
      const lowerSearchVal = searchVal.toLowerCase()

      const searchedLists = destinationLists.filter((listInfo) => {
        return Boolean(
          listInfo && (
            (listInfo.name && listInfo.name.toLowerCase().includes(lowerSearchVal)) ||
            (listInfo.firstName && listInfo.firstName.toLowerCase().includes(lowerSearchVal)) ||
            (listInfo.lastName && listInfo.lastName.toLowerCase().includes(lowerSearchVal))
            // (listInfo.unitName && listInfo.unitName.toLowerCase().includes(lowerSearchVal))
          )
        )
      })

      setFilteredLists(searchedLists)
    }
  }, [destinationLists, searchVal])

  const handleNewDestination = () => {
    if (ValidateUrl(newDestination)) {
      const destinationID = `DI${uuidv4().replace(/-/g, '')}`

      const tempDestinations = [...destinations]

      const hasDestination = tempDestinations.findIndex((destinationInfo) => destinationInfo.destination === newDestination) !== -1
      if (!hasDestination) {
        tempDestinations.push({ destination: newDestination, comment: '', destinationID })

        setDestinations(tempDestinations)
        setNewDestination('')
      } else {
        NotificationToast(false, 'Destinaiton already added!', true)
      }
    } else {
      NotificationToast(false, 'Invalid url!', true)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key) {
      if (e.key.toUpperCase() === 'ENTER') {
        handleNewDestination()
      }
    }
  }

  const handleDestinationClear = (destinationID) => {
    const tempDestinations = [...destinations]
    const newDestinations = tempDestinations.filter((destinationInfo) => destinationInfo && destinationInfo.destinationID !== destinationID)
    setDestinations(newDestinations)
  }

  const handleCancel = () => {
    setNewDestination('')
    setDestinations([])
    setDestinationListUnit([])
    setIsCreatingNew(false)
  }

  const handleUnitChange = (e, displayInfo) => {
    const tempUnits = [...destinationListUnit]

    if (e.target.checked) {
      tempUnits.push(displayInfo)
      setDestinationListUnit(tempUnits)
    } else {
      const newUnits = tempUnits.filter((unitInfo) => unitInfo && unitInfo.unitID !== displayInfo.unitID)
      setDestinationListUnit(newUnits)
    }
  }

  const handleCreate = async () => {
    if (destinationListName) {
      if (newDestination) {
        NotificationToast(false, 'Destination field is not empty. Please submit destination or clear field.', true)
        return false
      }

      const unitListLength = destinationListUnit.length

      const listUnits = destinationListUnit.reduce((unitStr, unitInfo, unitIndex) => {
        if (unitInfo && unitInfo.unitID && unitInfo.unitName && unitSettings[unitInfo.unitID]) {
          unitStr += `${unitInfo.unitName}${(unitIndex + 1) === unitListLength ? '' : ', '}`
        }
        return unitStr
      }, '')

      const newDestinationList = {
        name: destinationListName,
        units: destinationListUnit,
        destinations: destinations
      }

      if (listUnits) {
        const results = await ConfirmToast({ msg: 'The following units will be reassigned', txt: listUnits })
        if (!results) { return false }
      }

      dispatch(addDestinationList(newDestinationList, fireCreateSuccess, fireCreateFailure))
    }
  }

  const fireCreateSuccess = () => {
    setDestinations([])
    setDestinationListUnit([])
    setIsCreatingNew(false)
    setNewDestination('')
    setDestinationListName('')

    NotificationToast(false, 'Successfully added destination list.')
  }

  const fireCreateFailure = () => {
    NotificationToast(true, 'Failed to add destination list.')
  }

  // const handleDelete = async (e, listInfo) => {
  //   e.stopPropagation()
  //   let unitMappings = ''

  //   if (listInfo && listInfo.mappings) {
  //     const mappingLength = listInfo.mappings.length

  //     const mappingText = listInfo.mappings.reduce((mappingStr, mappingInfo, mappingIndex) => {
  //       if (mappingInfo && mappingInfo.unitName) {
  //         mappingStr += `${mappingInfo.unitName}${(mappingIndex + 1) === mappingLength ? '' : ', '}`
  //       }

  //       return mappingStr
  //     }, '')

  //     unitMappings = mappingText
  //   }

  //   const results = await ConfirmToast({ msg: 'Are you sure you want to delete this list?', txt: unitMappings ? `The following units will be unassigned: ${unitMappings}` : '' })

  //   if (results) {
  //     if (listInfo && listInfo.destinationListID && listInfo.id) {
  //       const { destinationListID, id: ciscoID } = listInfo
  //       dispatch(deleteDestinationList(destinationListID, ciscoID, fireDeleteSuccess, fireDeleteFailure))
  //     } else {
  //       // Probably never gonna happen
  //       NotificationToast(false, 'Missing destination list id!', true)
  //     }
  //   }
  // }

  // const fireDeleteSuccess = () => {
  //   NotificationToast(false, 'Successfully deleted destination list.')
  // }

  // const fireDeleteFailure = () => {
  //   NotificationToast(true, 'Failed to delete destination list.')
  // }

  return (
    <Grid container direction='row'>
      <Grid item container direction='column' justify='flex-start' spacing={2} className='mx-auto w-100'>

        <Grid container item direction='row'>
          <Grid item>
            <h2>Cisco Destination Lists</h2>
          </Grid>
        </Grid>

        <Grid container item direction='row'>
          <Grid item xs={12}>
            <Card raised elevation={3}>
              <CardContent>

                <Grid container direction='row'>
                  <Grid container item direction='column' spacing={3} className='mx-auto w-100'>

                    <Grid container item direction='row' justify='center' spacing={1} className='m-auto w-100'>
                      <Grid item xs>
                        <div className={classes.search}>
                          <div className={classes.searchIcon}>
                            <Fab
                              className={classes.searchBtn}
                              size='small'
                            >
                              <SearchIcon />
                            </Fab>
                          </div>
                          <InputBase
                            placeholder='Search Destination Lists...'
                            classes={{
                              root: classes.searchRoot,
                              input: classes.searchInput
                            }}
                            inputProps={{ 'aria-label': 'search' }}
                            onChange={(e) => {
                              setSearchVal(e.target.value)
                            }}
                            value={searchVal}
                            endAdornment={
                              searchVal !== ''
                                ? (
                                  <InputAdornment position='start'>
                                    <IconButton onClick={() => setSearchVal('')}>
                                      <ClearIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ) : (<></>)
                            }
                          />
                        </div>
                      </Grid>

                      <Grid item>
                        <Grid container direction='row'>
                          <Grid container item direction='column' alignItems='center'>
                            <Grid item>
                              <Typography variant='button' className={classes.listName}>Destination Lists:</Typography>
                            </Grid>

                            <Grid item>
                              <Chip
                                label={
                                  <Typography variant='overline' className='font-weight-bold'>
                                    {filteredLists.length}
                                  </Typography>
                                }
                                className={classes.countChip}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item container direction='row' className={classes.destinationListContainer}>
                      <Grid item container direction='column' spacing={1} className='mx-auto w-100'>

                        {
                          filteredLists.length
                            ? filteredLists.map((listInfo) => {
                              const {
                                destinationListID, name: destinationListName, meta: { destinationCount = 0 } = {}, mappings: unitMappings = []
                                // isGlobal: isListGlobal = false, emailAddress = '', firstName, lastName, createdBy,
                                // modifiedAt = 0, createdAt = 0
                              } = listInfo

                              return (
                                <Grid container item direction='row' className='px-0' key={`destination-list-${destinationListID}`}>
                                  <Grid item xs={12}>

                                    <Accordion elevation={3}>
                                      <AccordionSummary classes={{ content: classes.accordionContent }}>
                                        <Grid container direction='row' wrap='nowrap' alignItems='center'>

                                          <Grid item xs>
                                            <Grid container direction='row'>
                                              <Grid item container direction='column'>

                                                <Grid container item className='m-auto w-100' direction='row' alignItems='baseline' wrap='nowrap' justify='space-between' spacing={1}>
                                                  <Grid item xs>
                                                    <Grid container direction='row'>
                                                      <Grid container item direction='column' alignItems='center'>
                                                        <Grid item>
                                                          <Typography variant='button' className={classes.listName}>Name:</Typography>
                                                        </Grid>

                                                        <Grid item>
                                                          <Typography variant='overline'>{destinationListName}</Typography>
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>

                                                  <Divider orientation='vertical' flexItem />

                                                  <Grid item xs>
                                                    <Grid container direction='row'>
                                                      <Grid container item direction='column'>
                                                        <Grid item container direction='row' justify='center'>
                                                          <Grid item>
                                                            <Typography align='center' variant='button' className={classes.listName}>Used In:</Typography>
                                                          </Grid>
                                                        </Grid>

                                                        <Grid item container direction='row' justify='space-evenly' spacing={1} className='mx-auto w-100'>
                                                          {
                                                            unitMappings.length
                                                              ? unitMappings.map((mappingInfo) => {
                                                                const { unitID, display: unitDisplay = '', unitName } = mappingInfo

                                                                return (
                                                                  <Grid item key={`destination-mapping-${unitID}`} className='py-0'>
                                                                    <Tooltip arrow title={unitDisplay}>
                                                                      <Link variant='overline' component='button' className='font-weight-bold' onClick={(e) => e.stopPropagation()}>
                                                                        {unitName}
                                                                      </Link>
                                                                    </Tooltip>
                                                                  </Grid>
                                                                )
                                                              }) : (
                                                                <Grid item>
                                                                  <Typography variant='overline'>No mappings found</Typography>
                                                                </Grid>
                                                              )
                                                          }
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>

                                                  <Divider orientation='vertical' flexItem />

                                                  <Grid item xs>
                                                    <Grid container direction='row'>
                                                      <Grid container item direction='column' alignItems='center'>
                                                        <Grid item>
                                                          <Typography variant='button' className={classes.listName}>Destinations:</Typography>
                                                        </Grid>

                                                        <Grid item>
                                                          <Chip
                                                            label={
                                                              <Typography variant='overline' className='font-weight-bold'>
                                                                {destinationCount}
                                                              </Typography>
                                                            }
                                                            className={classes.countChip}
                                                          />
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>

                                                </Grid>

                                                {/* <Grid container item direction='row'>
                                                  <Grid item xs>
                                                    <Divider variant='fullWidth' />
                                                  </Grid>
                                                </Grid> */}

                                                {/* <Grid container item className='m-auto w-100' direction='row' alignItems='baseline' wrap='nowrap' justify='space-between' spacing={1}>
                                                  <Grid item xs>
                                                    <Tooltip arrow title={emailAddress || 'umbrella.cisco.com'}>
                                                      <Grid container direction='row'>
                                                        <Grid container item direction='column' alignItems='center'>
                                                          <Grid item>
                                                            <Typography variant='button' className={classes.listName}>Created By:</Typography>
                                                          </Grid>

                                                          <Grid item>
                                                            <Typography variant='overline'>{createdBy ? `${firstName} ${lastName}` : 'Cisco Umbrella'}</Typography>
                                                          </Grid>
                                                        </Grid>
                                                      </Grid>
                                                    </Tooltip>
                                                  </Grid>

                                                  <Divider orientation='vertical' flexItem />

                                                  <Grid item xs>
                                                    <Grid container direction='row'>
                                                      <Grid container item direction='column' alignItems='center'>
                                                        <Grid item>
                                                          <Typography variant='button' className={classes.listName}>Created At:</Typography>
                                                        </Grid>

                                                        <Grid item>
                                                          <Typography variant='overline'>{typeof createdAt === 'number' ? moment.unix(createdAt).format('MM/DD/YYYY') : moment(createdAt).format('MM/DD/YYYY')}</Typography>
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>

                                                  <Divider orientation='vertical' flexItem />

                                                  <Grid item xs>
                                                    <Grid container direction='row'>
                                                      <Grid container item direction='column' alignItems='center'>
                                                        <Grid item>
                                                          <Typography variant='button' className={classes.listName}>Updated At:</Typography>
                                                        </Grid>

                                                        <Grid item>
                                                          <Typography variant='overline'>{moment(modifiedAt).format('MM/DD/YYYY')}</Typography>
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>
                                                </Grid> */}

                                              </Grid>
                                            </Grid>
                                          </Grid>

                                          {/* <Divider orientation='vertical' variant='fullWidth' flexItem className='mr-3' />

                                          <Grid item>
                                            <IconButton disabled={isListGlobal} size='medium' className={classes.deleteBtn} onClick={(e) => handleDelete(e, listInfo)}>
                                              <DeleteIcon />
                                            </IconButton>
                                          </Grid> */}

                                        </Grid>
                                      </AccordionSummary>
                                    </Accordion>

                                  </Grid>
                                </Grid>
                              )
                            }) : (
                              <Grid container item direction='row' className='px-0' justify='center'>
                                <Grid item>
                                  <Typography variant='button'>No destination lists found</Typography>
                                </Grid>
                              </Grid>
                            )
                        }

                      </Grid>
                    </Grid>

                    {
                      isCreatingNew
                        ? (
                          <Grid container item direction='row'>
                            <Grid item xs={12}>

                              <Card elevation={3} raised>
                                <CardContent>
                                  <Grid container direction='row'>
                                    <Grid container item direction='column' spacing={1} className={classes.listcontainer}>

                                      <Grid container item direction='row' spacing={2} className='pt-0 px-0 mx-auto w-100'>

                                        <Grid item>
                                          <Grid container item direction='column' spacing={1} className='mx-auto w-100'>
                                            <Grid item>
                                              <Typography variant='button' className={classes.listName}>OU Mappings:</Typography>
                                            </Grid>

                                            <Grid item>
                                              <Grid container direction='row' className={classes.unitListContainer}>
                                                <Grid container item direction='column' spacing={1} className='m-auto w-100' alignItems='stretch'>

                                                  {
                                                    unitDisplays && unitDisplays.map((displayInfo) => {
                                                      const { unitID: displayUnitID = '', display: unitDisplay } = displayInfo

                                                      const isChecked = Boolean(destinationListUnit.findIndex((unitInfo) => unitInfo.unitID === displayUnitID) !== -1)

                                                      return (
                                                        <Grid item key={`list-button-${displayUnitID}`}>
                                                          <FormControlLabel
                                                            control={
                                                              <GreenCheckbox
                                                                onChange={(e) => handleUnitChange(e, displayInfo)}
                                                                checked={isChecked}
                                                                size='small'
                                                              />
                                                            }
                                                            label={<Typography variant='overline'>{unitDisplay}</Typography>}
                                                            className={classes.displayCheckbox}
                                                          />
                                                        </Grid>
                                                      )
                                                    })
                                                  }

                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>

                                        <Divider orientation='vertical' flexItem />

                                        <Grid item xs>
                                          <Grid container item direction='column' spacing={2} className='mx-auto w-100'>

                                            <Grid item container direction='row' spacing={1} className='px-0 mx-auto w-100'>

                                              <Grid item xs>
                                                <Grid container direction='row'>
                                                  <Grid container item direction='column' spacing={1} className='mx-auto w-100'>
                                                    <Grid item className='px-0'>
                                                      <Typography variant='button' className={classes.listName}>New List Name:</Typography>
                                                    </Grid>

                                                    <Grid item className='px-0'>
                                                      <CustomTextField
                                                        name='destinationListName'
                                                        variant='outlined'
                                                        value={destinationListName}
                                                        onChange={(e) => setDestinationListName(e.target.value)}
                                                        fullWidth
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>

                                              <Grid item>
                                                <Grid container direction='row'>
                                                  <Grid container item direction='column' spacing={1} className='mx-auto w-100'>
                                                    <Grid item>
                                                      <Typography variant='button' className={classes.listName}>OUs Mapped:</Typography>
                                                    </Grid>

                                                    <Grid item>
                                                      <CustomTextField
                                                        name='destinationListUnit'
                                                        variant='outlined'
                                                        value={destinationListUnit.length ? destinationListUnit.map((unitInfo) => ` ${unitInfo.unitName}`) : '--'}
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>

                                            </Grid>

                                            <Grid container item direction='row' className='px-0'>
                                              <Grid container item direction='column' spacing={1} className='mx-auto w-100'>

                                                <Grid item>
                                                  <Typography variant='button' className={classes.listName}>Destinations:</Typography>
                                                </Grid>

                                                <Grid item>
                                                  <Grid container direction='row' spacing={2} className='mx-auto w-100' alignItems='center'>
                                                    <Grid item xs className='pl-0'>
                                                      <CustomTextField
                                                        name='destinations'
                                                        variant='outlined'
                                                        value={newDestination}
                                                        fullWidth
                                                        onKeyDown={handleKeyPress}
                                                        onChange={(e) => setNewDestination(e.target.value)}
                                                      />
                                                    </Grid>

                                                    <Grid item>
                                                      <IconButton
                                                        size='small'
                                                        disabled={!newDestination}
                                                        className={classes.addDestinationBtn}
                                                        onClick={handleNewDestination}
                                                      >
                                                        <AddIcon />
                                                      </IconButton>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>

                                              </Grid>
                                            </Grid>

                                            <Grid container item direction='row' className='px-0' justify='center'>
                                              <Grid item xs>
                                                <List className={classes.destinationsList}>

                                                  {
                                                    destinations.length
                                                      ? destinations.map((destinationInfo) => {
                                                        const { destinationID, destination } = destinationInfo
                                                        return (
                                                          <React.Fragment key={`destination-list-item-${destinationID}`}>
                                                            <Divider variant='fullWidth' />

                                                            <ListItem>
                                                              <ListItemText inset primary={destination} primaryTypographyProps={{ variant: 'overline' }} />

                                                              <ListItemSecondaryAction>
                                                                <IconButton
                                                                  size='small'
                                                                  className={classes.clearDestinationBtn}
                                                                  onClick={() => handleDestinationClear(destinationID)}
                                                                >
                                                                  <ClearIcon />
                                                                </IconButton>
                                                              </ListItemSecondaryAction>
                                                            </ListItem>
                                                          </React.Fragment>
                                                        )
                                                      }) : (
                                                        <ListItemText inset primary='No destinations selected...' primaryTypographyProps={{ variant: 'overline' }} />
                                                      )
                                                  }

                                                </List>
                                              </Grid>
                                            </Grid>

                                          </Grid>
                                        </Grid>

                                      </Grid>

                                      <Grid item container direction='row'>
                                        <Grid item xs>
                                          <Divider variant='fullWidth' />
                                        </Grid>
                                      </Grid>

                                      <Grid container item direction='row' justify='space-between' className='px-0'>
                                        <Grid item>
                                          <Button variant='contained' className={classes.clearDestinationBtn} onClick={handleCancel}>Cancel</Button>
                                        </Grid>

                                        <Grid item>
                                          <Button variant='contained' disabled={!destinationListName} className={classes.addDestinationBtn} onClick={handleCreate}>Create</Button>
                                        </Grid>

                                      </Grid>

                                    </Grid>
                                  </Grid>
                                </CardContent>
                              </Card>

                            </Grid>
                          </Grid>
                        ) : (
                          <>
                            {/* <Grid container item direction='row' justify='center'>
                              <Button
                                startIcon={<AddIcon />}
                                variant='contained'
                                className={classes.newListBtn}
                                onClick={() => setIsCreatingNew(true)}
                              >
                                New List
                              </Button>
                            </Grid> */}
                          </>
                        )
                    }
                  </Grid>
                </Grid>

              </CardContent>
            </Card>
          </Grid>
        </Grid>

      </Grid>
    </Grid>
  )
}

export default CiscoLists
